import { useEffect, useState } from 'react'
import { usePageLoading } from '../lib/pageLoading'

export function LoadingOrb({ floating = false }: { floating?: boolean }) {
  return <div className={`loading-orb${floating ? ' loading-orb--floating' : ''}`} role="status" aria-live="polite">
    <span className="loading-orb-art" aria-hidden="true"><span className="loading-orb-core" /><span className="loading-orb-ring" /><span className="loading-orb-satellite" /></span>
    <span className={floating ? 'loading-orb-label' : 'sr-only'}>Loading page…</span>
  </div>
}

/** Fast navigation never flashes a loader; polling never registers as page loading. */
export default function PageLoadingIndicator() {
  const pending = usePageLoading()
  return pending ? <DelayedOrb /> : null
}

function DelayedOrb() {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const timer = window.setTimeout(() => setVisible(true), 120)
    return () => window.clearTimeout(timer)
  }, [])
  return visible ? <LoadingOrb floating /> : null
}
